export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      action: '',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-dashboard',
      },
    },
    {
      name: 'courses',
      displayName: '课程系统',
      businessName: 'course',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-tables',
      },
      children: [
        /*        {
          name: 'listService',
          displayName: '服务列表',
        }, */
        {
          name: 'listAllCourse',
          displayName: '全部课程排序',
          action: 'list_course',
        },
        {
          name: 'listLibaPreview',
          displayName: '篱笆预告列表',
          action: 'list_course',
        },
        {
          name: 'listFreeOpenCourse',
          displayName: '免费公开课列表',
          action: 'list_course',
        },
        {
          name: 'listOnlineAction',
          displayName: '在线项目实战列表',
          action: 'list_course',
        },
        {
          name: 'listJobCounseling',
          displayName: '求职辅导列表',
          action: 'list_course',
        },
        {
          name: 'listEnterpriseToOne',
          displayName: '名企一对一列表',
          action: 'list_course',
        },
        {
          name: 'listLecture',
          displayName: '分享会/讲座列表',
          action: 'list_course',
        },
      ],
    },
    {
      name: 'referrals',
      displayName: '岗位系统',
      businessName: 'referral',
      meta: {
        iconClass: 'maki maki-commerical-building va-icon maki maki-commerical-building',
      },
      children: [
        {
          name: 'listReferral',
          displayName: '岗位列表',
          action: 'list_referral',
        },
        {
          name: 'listOrganization',
          displayName: '企业列表',
          action: 'list_referral_organization',
        },
        {
          name: 'listCareerMonitor',
          displayName: '岗位监测',
          action: 'list_career_monitor',
        },
        {
          name: 'listDataSource',
          displayName: '数据源列表',
          action: 'list_career_monitor',
        },
      ],
    },
    {
      name: 'tags',
      displayName: '标签系统',
      businessName: 'tag',
      meta: {
        iconClass: 'maki maki-commerical-building va-icon maki maki-commerical-building',
      },
      children: [
        {
          name: 'listTag',
          displayName: '标签列表',
          action: 'list_tag',
        },
      ],
    },
    {
      name: 'blogs',
      displayName: '博客管理',
      businessName: 'blog',
      meta: {
        iconClass: 'fa fa-book',
      },
      children: [
        {
          name: 'listBlog',
          displayName: '博客列表',
          action: 'list_blog',
        },
      ],
    },
    {
      name: 'mentors',
      displayName: '导师管理',
      businessName: 'mentor',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-user',
      },
      children: [
        {
          name: 'listMentor',
          displayName: '导师列表',
          action: 'list_mentor',

        },
        {
          name: 'listConsulting',
          displayName: '导师咨询列表',
          action: 'list_consulting',
        },
        {
          name: 'listMentorApplication',
          displayName: '导师申请表',
          action: 'list_mentor_application',
        },
        {
          name: 'listAuditingConsulting',
          displayName: '咨询审核列表',
          action: 'list_auditing',
        },
        {
          name: 'listAuditingCourse',
          displayName: '课程审核列表',
          action: 'list_auditing',
        },
        {
          name: 'listComment',
          displayName: '评论列表',
          action: 'list_comment',
        },
      ],
    },
    {
      name: 'Users',
      displayName: '用户管理',
      businessName: 'user',
      meta: {
        iconClass: 'entypo entypo-users va-icon entypo entypo-users',
      },
      children: [
        {
          name: 'listUser',
          displayName: '用户列表',
          action: 'list_user',
        },
      ],
    },
    {
      name: 'virtualMoney',
      displayName: '积分管理',
      businessName: 'virtual_money',
      meta: {
        iconClass: 'entypo entypo-box va-icon entypo entypo-box',
      },
      children: [
        {
          name: 'listVirtualMoneyRecord',
          displayName: '积分记录',
          action: 'list_virtual_money_record',
        },
      ],
    },
    {
      name: 'group',
      displayName: '群组管理',
      businessName: 'group',
      meta: {
        iconClass: 'entypo-chat',
      },
      children: [
        {
          name: 'listGroup',
          displayName: '群组列表',
          action: 'list_group',
        },
        {
          name: 'listPrivateGroup',
          displayName: '群聊列表',
          action: 'list_private_group',
        },
        {
          name: 'listC2cGroup',
          displayName: '单聊列表',
          action: 'list_c2c_group',
        },
      ],
    },
    {
      name: 'application',
      displayName: '报名管理',
      businessName: 'application',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-components va-icon vuestic-iconset vuestic-iconset-components',
      },
      children: [
        {
          name: 'listAppliedCourse',
          displayName: '课程报名列表',
          action: 'list_application',
        },
        {
          name: 'listAppliedConsulting',
          displayName: '咨询报名列表',
          action: 'list_application',
        },
      ],
    },
    {
      name: 'interviewQuestion',
      displayName: '面经管理',
      businessName: 'interview',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-forms',
      },
      children: [
        {
          name: 'listPost',
          displayName: '面经干货',
          action: 'list_post',
        },
        {
          name: 'listInterviewQuestion',
          displayName: '面经真题列表',
          action: 'list_interview_question',
        },
        {
          name: 'listPracticeQuestion',
          displayName: '练习题列表',
          action: 'list_practice_question',
        },
        {
          name: 'listOrganization',
          displayName: '企业列表',
          action: 'list_organization',
        },
        {
          name: 'listPositionTag',
          displayName: '职位列表',
          action: 'list_tag',
        },
      ],
    },
    {
      name: 'openJob',
      displayName: '开放岗位',
      businessName: 'openJob',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-forms',
      },
      children: [
        {
          name: 'listJobUser',
          displayName: '用户列表',
          action: 'all',
        },
        {
          name: 'interviewInbox',
          displayName: '面试邀请展示',
          action: 'all',
        },
        {
          name: 'autoApplySuccessRate',
          displayName: '代投成功率',
          action: 'all',
        },
        {
          name: 'pushDeliverStats',
          displayName: '推送/代投统计',
          action: 'all',
        },
      ],
    },
    {
      name: 'permission',
      displayName: '权限管理',
      businessName: 'system',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-ui-elements va-icon vuestic-iconset vuestic-iconset-ui-elements',
      },
      children: [
        {
          name: 'listRole',
          displayName: '角色列表',
          action: 'assign_roles',
        },
        {
          name: 'listBusiness',
          displayName: '业务列表',
          action: 'super_admin_access',
        },
        {
          name: 'listPermission',
          displayName: '权限列表',
          action: 'super_admin_access',
        },
      ],
    },
    {
      name: 'employee',
      displayName: '员工管理',
      businessName: 'employee',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-ui-elements va-icon vuestic-iconset vuestic-iconset-ui-elements',
      },
      children: [
        {
          name: 'listEmployee',
          displayName: '员工列表',
          action: 'list_employee',
        },
      ],

    },

  ],
}
